<div #tooltipEl>
  <ng-content select="[slot=content]"></ng-content>
</div>

<div class="trigger" #triggerEl>
  <span #triggerRef><ng-content select="[slot=trigger]"></ng-content></span>
  <div *ngIf="!triggerRef.innerHTML.trim()">
    <studio-button-legacy [isIconOnly]="true" theme="secondary" slot="trigger">
      <studio-icon name="questionMark" title="Information" size="12"></studio-icon>
    </studio-button-legacy>
  </div>
</div>
